import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // Доступ
    accessPublic: 'В каталоге',
    accessLink: 'По ссылке',
    accessPrivate: 'Закрытый доступ',
    timeToReadHint: 'Формат: PT5M (только минуты, ISO 8601)',
    // Поля статьи
    fieldTitle: 'Заголовок',
    fieldContent: 'Текст',
    fieldTitleEn: 'Заголовок (EN)',
    fieldContentEn: 'Текст (EN)',
    image: 'Картинка',
    linkN: (field: string, n: number) => `${field} · Ссылка ${n}`,
    // Ошибки
    fieldRejected: (field: string, msg: string) => `Сервер не принял поле «${field}»: ${msg}`,
    styleGradient: 'Градиент обложки в неверном формате — выберите его заново',
    styleTitleColor: 'Цвет заголовка в неверном формате: нужен #RRGGBB',
    styleBorderColor: 'Цвет рамки в неверном формате: нужен #RRGGBB',
    styleInvalid: 'Оформление статьи в неверном формате',
    published: 'Сначала снимите с публикации',
    articleInUse: 'Статья используется в курсах — отвяжите её сначала',
    uniqueError: 'Статья с таким адресом уже существует',
    network: 'Нет соединения с сервером. Проверьте интернет и попробуйте ещё раз.',
    forbidden: 'Нет прав на это действие',
    notFound: 'Статья не найдена',
    generic: 'Что-то пошло не так',
    // Провал перевода
    translateSafety: 'Перевод заблокирован фильтром безопасности AI. Проверьте контент статьи.',
    translateHtml: 'Не удалось сохранить HTML-разметку. Попробуйте упростить статью.',
    translateGemini: 'Сервис перевода вернул ошибку. Свяжитесь с поддержкой.',
    translateRetryable: 'Сервис временно недоступен, попробуйте позже.',
    translateInReview: 'Перевод не сохранён: статья ушла на проверку. Запустите после решения',
    translateFailed: 'Ошибка перевода',
  },
  en: {
    accessPublic: 'In catalog',
    accessLink: 'By link',
    accessPrivate: 'Private',
    timeToReadHint: 'Format: PT5M (minutes only, ISO 8601)',
    fieldTitle: 'Title',
    fieldContent: 'Text',
    fieldTitleEn: 'Title (EN)',
    fieldContentEn: 'Text (EN)',
    image: 'Image',
    linkN: (field: string, n: number) => `${field} · Link ${n}`,
    fieldRejected: (field: string, msg: string) =>
      `The server rejected the “${field}” field: ${msg}`,
    styleGradient: 'Invalid cover gradient — choose it again',
    styleTitleColor: 'Invalid title color — use the #RRGGBB format',
    styleBorderColor: 'Invalid border color — use the #RRGGBB format',
    styleInvalid: 'Invalid article design format',
    published: 'Unpublish the article first',
    articleInUse: 'The article is used in courses — unlink it first',
    uniqueError: 'An article with this URL already exists',
    network: 'No connection to the server. Check your internet and try again.',
    forbidden: 'You don’t have permission to do this',
    notFound: 'Article not found',
    generic: 'Something went wrong',
    translateSafety: 'Translation was blocked by the AI safety filter. Check the article content.',
    translateHtml: 'Couldn’t save the HTML markup. Try simplifying the article.',
    translateGemini: 'The translation service returned an error. Contact support.',
    translateRetryable: 'The service is temporarily unavailable. Try again later.',
    translateInReview:
      'Translation not saved: the article was sent for review. Translate it again once the review is done',
    translateFailed: 'Translation failed',
  },
})
